// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d1a80309","513":"15479f59","787":"767122d2"}[chunkId] + ".chunk.js";
};